import { SERVICES_A } from "./servicesA";
import { SERVICES_B } from "./servicesB";

export const SERVICES = [...SERVICES_A, ...SERVICES_B];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
